// extracted by mini-css-extract-plugin
export default {"image":"image__t1nDM","left":"left__Ia9ng","center":"center__vw94N","right":"right__ay_qy","hidden":"hidden__TTSgo","disabled":"disabled__l0Hj0"};